import { render, staticRenderFns } from "./driverVehicle.vue?vue&type=template&id=274adc51&scoped=true&"
import script from "./driverVehicle.vue?vue&type=script&lang=js&"
export * from "./driverVehicle.vue?vue&type=script&lang=js&"
import style0 from "./driverVehicle.vue?vue&type=style&index=0&id=274adc51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274adc51",
  null
  
)

export default component.exports